const colors = {
  black: "#000000",
  grey01: "#333333",
  grey02: "#666666",
  grey03: "#808080",
  grey04: "#999999",
  grey05: "#b2b2b2",
  grey06: "#d9d9d9",
  grey07: "#ededed",
  grey08: "#f2f2f2",
  grey09: "#f7f7f7",
  grey10: "#fafafa",
  grey11: "#6e6e6e",
  white: "#ffffff",
  divider: "#e5e5e5",
  red: "#ff0000",
  red01: "#cc0000",
  red02: "#e50000",
  red03: "#ff3333",
  red04: "#ff6666",
  green: "#0d6c29",
  green01: "#298236",
  green02: "#34a344",
  green03: "#5cb569",
  green04: "#85c78e",
  green05: "#00a865",
  green06: "#00954b",
  green07: "#a6ce39",
};

export default colors;
